<template>
  <div class="topic-viewer">
    <div class="header">
      <h2>{{ topic.title }}</h2>
      <h4><a :href="topic.livingMaPath" target="_blank"><i class="fas fa-link"/>  Living Meta-Analysis</a></h4>
    </div>
    <div class="tabs">
      <div class="tab" v-for="tab in tabs"
           @click="e => activeTab = tab.value"
           :class="{active: activeTab === tab.value}"
      >{{ tab.label }}
      </div>
    </div>
    <div class="tab-viewer">
      <template v-if="activeTab === 0">
        <RctListTile v-for="rct in topic.rct" :rct="rct" :key="rct.id" />
      </template>
      <template v-if="activeTab === 1">
        <SrListTile v-for="sr in topic.sr" :sr="sr" :key="sr.id" />
      </template>
      <template v-if="activeTab === 2">
        <ProtListTile v-for="prot in topic.prot" :prot="prot" :key="prot.id" />
      </template>

    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, PropType, ref} from "vue";
import {ITopic} from "@/interfaces/evidence-map";
import SrListTile from "@/components/SrListTile.vue";
import ProtListTile from "@/components/ProtListTile.vue";
import RctListTile from "@/components/RctListTile.vue";

export default defineComponent({
  name: "TopicViewer",
  components: {SrListTile, RctListTile, ProtListTile},
  props: {
    topic: {
      type: Object as PropType<ITopic>
    }
  },
  setup(props) {
    const tabs = [
      {label: `${props.topic.rct.length} RCT`, value: 0},
      {label: `${props.topic.sr.length} SR`, value: 1},
      {label: `${props.topic.prot.length} Ongoing`, value: 2},
    ]
    const activeTab = ref(0);
    return {
      tabs,
      activeTab,
    }

  }
})
</script>
<style lang="scss">
@import "src/assets/styles/vars";
.topic-viewer{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header{
    padding: 4vh $default-padding;
    background-color: $primary;
    h2{
      color: white;
      margin-bottom: 3.5vh;
    }
    h4 {
      margin: 2vh 0 1vh 0;
      font-size: 1.6vh;
      font-weight: bold;
      a,i {
        color: white;
        &:hover {
          color: $accent
        }
      }
    }
  }
  .tabs{
    display: flex;
    .tab{
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      background-color: $primary;
      height: 4vh;
  font-size:$list-tile-font-size;      cursor: pointer;
      padding-bottom: 5px;
      &:hover{
        border-bottom: 5px solid $special;
        padding-bottom: 0;
        color: white;
      }
      &.active {
        padding-bottom: 0;
        border-bottom: 5px solid $special;
      }

    }
  }
  .tab-viewer{
    height: 0;
    flex-grow: 1;
    overflow: auto;
  }
}
</style>